var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"preloader"},[_c('img',{attrs:{"src":require("../assets/logo.png"),"alt":"preloader"}}),_c('p',[_vm._v(_vm._s(_vm.message || 'Загрузка'))])])
}
var staticRenderFns = []

export { render, staticRenderFns }